//const dotenv = require('dotenv');
//export const API_ORIGIN = "http://api.pathr.ai"
//export const POSTURL = "https://api.pathr.ai";// "http://calibration-tool-backend.rc.k8s";//"http://api.pathr.ai";
//export const APIURL = "https://api.pathr.ai/rc/calib_backend"; //"http://calibration-tool-backend.rc.k8s";//"http://api.pathr.ai/rc/calib_backend";

export const REACT_APP_API = window._env_.REACT_APP_API
